export default "__VITE_ASSET__DePs7$Tv__"